@if (!isTablet) {
  <div class="usa-accordion sidebar-mobile">
    <h3 class="usa-accordion__heading">
      <button
        type="button"
        class="usa-accordion__button"
        aria-expanded="false"
        aria-controls="basic-search"
      >
        <span>Basic Search</span>
      </button>
    </h3>
    <div id="basic-search" class="usa-accordion__content">
      <global-search />
      <ul class="usa-list usa-list--unstyled margin-top-2">
        <li>
          <a class="usa-link" [routerLink]="['/characteristics-search']"
            ><span>Characteristic Search</span></a
          >
        </li>
        <li>
          <a class="usa-link" [routerLink]="['/duration-search']"><span>Duration Search</span></a>
        </li>
        <li>
          <factsheet-plantguide-search />
        </li>
        <li>
          <a class="usa-link" [routerLink]="['/group-search']"><span>Group Search</span></a>
        </li>
        <li>
          <a class="usa-link" [routerLink]="['/growth-habit-search']"
            ><span>Growth Habit Search</span></a
          >
        </li>
        <li>
          <a class="usa-link" [routerLink]="['/image-search']"><span>Image Search</span></a>
        </li>
        <li>
          <a class="usa-link" [routerLink]="['/noxious-invasive-search']"
            ><span>Invasive/Noxious Search</span></a
          >
        </li>
        <li>
          <a class="usa-link" [routerLink]="['/rarity-search']"><span>Rarity Search</span></a>
        </li>
        <li>
          <a class="usa-link" [routerLink]="['/state-search']"><span>State Search</span></a>
        </li>
        <li>
          <a class="usa-link" [routerLink]="['/wetland-search']"><span>Wetland Search</span></a>
        </li>
      </ul>
    </div>
  </div>
  @if (router.url === "/characteristics-search" || router.url.includes("search-results")) {
    <div class="usa-accordion sidebar-mobile">
      <h3 class="usa-accordion__heading">
        <button
          type="button"
          class="usa-accordion__button"
          aria-expanded="false"
          aria-controls="basic-filters-mobile"
        >
          <span>Filtering Options</span>
        </button>
      </h3>
      <div id="basic-filters-mobile" class="usa-accordion__content">
        @if (router.url === "/characteristics-search") {
          <basic-filters />
        } @else if (isShowingSearchResults()) {
          <top-level-filtering-options />
        }
      </div>
    </div>
  }
}
@if (isTablet) {
  <div class="sidebar-desktop">
    <global-search />
    <ul class="usa-list usa-list--unstyled margin-top-2">
      <li>
        <a class="usa-link" [routerLink]="['/characteristics-search']"
          ><span>Characteristic Search</span></a
        >
      </li>
      <li>
        <a class="usa-link" [routerLink]="['/duration-search']"><span>Duration Search</span></a>
      </li>
      <li>
        <factsheet-plantguide-search />
      </li>
      <li>
        <a class="usa-link" [routerLink]="['/group-search']"><span>Group Search</span></a>
      </li>
      <li>
        <a class="usa-link" [routerLink]="['/growth-habit-search']"
          ><span>Growth Habit Search</span></a
        >
      </li>
      <li>
        <a class="usa-link" [routerLink]="['/image-search']"><span>Image Search</span></a>
      </li>
      <li>
        <a class="usa-link" [routerLink]="['/noxious-invasive-search']"
          ><span>Invasive/Noxious Search</span></a
        >
      </li>
      <li>
        <a class="usa-link" [routerLink]="['/rarity-search']"><span>Rarity Search</span></a>
      </li>
      <li>
        <a class="usa-link" [routerLink]="['/state-search']"><span>State Search</span></a>
      </li>
      <li>
        <a class="usa-link" [routerLink]="['/wetland-search']"><span>Wetland Search</span></a>
      </li>
    </ul>
    @if (router.url === "/characteristics-search") {
      <basic-filters />
    } @else if (isShowingSearchResults()) {
      <top-level-filtering-options />
    }
  </div>
}
